export default __webpack_public_path__ + "static/media/Centaurus.170bb5b1.jpg";